import { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { JOB_DETAIL } from '@/page/constants'
import { getPageType } from '@/page/store/selectors'

import { navigateUp, showMobileSearchForm } from '../../search/store/actions'

const useEventHandlers = () => {
  const [open, setOpen] = useState(false)
  // up navigation from job detail should keep the url unchanged
  const updateUrl = useSelector((state) => getPageType(state) !== JOB_DETAIL)
  const dispatch = useDispatch()

  const toggleMainMenu = useCallback(() => {
    setOpen(!open)
  }, [open])

  const onNavigateUpClick = useCallback((event) => {
    event.preventDefault()
    dispatch(navigateUp(null, { updateUrl }))
  }, [dispatch, updateUrl])

  const onShowSearchForm = useCallback((event) => {
    event.preventDefault()
    dispatch(showMobileSearchForm())
  }, [dispatch])

  return { open, toggleMainMenu, onNavigateUpClick, onShowSearchForm }
}

export default useEventHandlers
